let notification_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'notifications', name: 'notifications.list', component: () => import('./pages/Index.vue') },
    ]
  }
];

export default notification_routes;
